<template>

    <div class="alert alert-danger" v-show="display" id="failed-payment">
        <p>Se opravičujemo, vendar je prišlo do napake pri izvedbi plačila.</p>
        <p>Prosimo poiskusite znova ali pa izberite drug način plačila.</p>
        <p>V primeru, da se napaka ponavlja, nas prosim kontaktirajte na <a href="mailto:tecaji@savinaatai.com">tecaji@savinaatai.com</a></p>
        <p>Opis napake: <b>{{this.error_message}}</b></p>
    </div>

</template>

<script>


    import {abstractField} from "vue-form-generator/dist/vfg-core.js";

    export default {
        mixins: [abstractField],

        data: function() {
            return {
                display: false,
                error_message: ""
            }
        },

        created() {
            Event.$on("process_order_error", function(message){
                this.display = true;
                this.error_message = message;

                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $("#failed-payment").offset().top - 30
                    }, 800);
                }, 500);



            }.bind(this));
        }

    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/fields/fieldFailedPayment.vue